import React, { useState, useEffect } from "react";
import { Button, Form } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import { Recipe } from "ceicons";
import graphql from "babel-plugin-relay/macro";
import { createFragmentContainer } from "react-relay";
import { toast } from "react-toastify";
import { commitMutation } from "react-relay";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";
import { isEmpty } from "lodash";

function AllergenRecipeModal(props) {
  const { trigger, edit, allergen, recipeId, allAllergen, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [allergenList, setAllergenList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const [formErrors, setFormErrors] = useState({});
  const t = useTranslation();

  useEffect(() => {
    setAllergenList(
      allAllergen.edges.map((allerg) => {
        return {
          key: allerg.node.id,
          text: allerg.node.name,
          value: allerg.node.id,
        };
      })
    );
  }, [allAllergen]);

  function addAllergenRecipe() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
        recipe: recipeId,
      };

      commitMutation(environment, {
        mutation: allergenRecipeModalAddMutation,
        variables,

        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  function editAllergenRecipe() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
        unity: formData?.unityF?.id,
        ingredient: formData.name,
        recipe: recipeId,
      };

      commitMutation(environment, {
        mutation: allergenRecipeModalUpdateMutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const handleChangeAllergen = (e, { value }) => {
    setFormData({
      ...formData,
      allergen: value,
    });
  };

  const addNewItemIngredient = ({ value }) => {
    setAllergenList([
      ...allergenList,
      { key: value, text: value, value: value },
    ]);
  };

  const onSubmit = async () => {
    if (validateForm()) {
      const action = !edit ? addAllergenRecipe : editAllergenRecipe;
      const msg = !edit
        ? t("message.added_allergen")
        : t("message.edited_allergen");

      action()
        .then((a) => {
          toast.success(msg);
          setModalOpen(false);
          setLoading(false);
          refetchData();
        })
        .catch((e) => {
          if (Array.isArray(e)) {
            toast.error(e[0].message);
          } else {
            toast.error(e?.errors[0]?.message);
          }
        });
    }
  };

  const validateForm = () => {
    let errors = {};
    let validate = true;

    if (!formData.allergen) {
      errors = { ...errors, allergen: t("form.errorRequired") };
    }
    if (!isEmpty(errors)) {
      validate = false;
    }

    setFormErrors(errors);
    return validate;
  };

  return (
    <BasicModal
      size="tiny"
      className="single-button"
      title={
        <div className="modalTitle">
          <Recipe />
          {edit ? t("modalTitle.editAllergen") : t("modalTitle.addAllergen")}
        </div>
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          edit
            ? setFormData({ id: allergen.id, allergen: allergen.allergen.id })
            : setFormData({});
        },
      })}
      actions={
        <Button
          type="submit"
          disabled={loading}
          onClick={() => {
            onSubmit();
          }}
          primary
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form>
        <Form.Field>
          <Form.Dropdown
            placeholder={t("form.allergen")}
            label={t("form.allergen")}
            name="allergen"
            error={formErrors && formErrors["allergen"]}
            search
            value={formData.allergen}
            noResultsMessage={t("message.noResultsAllergens")}
            selection
            onChange={handleChangeAllergen}
            options={allergenList}
            additionPosition="top"
            additionLabel={t("dropdown.newIngredient")}
            allowAdditions={true}
            onAddItem={(e, data) => {
              addNewItemIngredient(data);
            }}
            required
          />
        </Form.Field>
      </Form>
      <p className="required-modal">{t("form.required")}</p>
    </BasicModal>
  );
}
const allergenRecipeModalAddMutation = graphql`
  mutation AllergenRecipeModalCreateMutation($allergen: ID!, $recipe: ID!) {
    recipeAddAllergen(input: { allergen: $allergen, recipe: $recipe }) {
      recipeAllergen {
        id
        allergen {
          id
          name
          icon
        }
      }
    }
  }
`;

const allergenRecipeModalUpdateMutation = graphql`
  mutation AllergenRecipeModalUpdateMutation($id: ID!, $allergen: ID!) {
    recipeUpdateAllergen(input: { id: $id, allergen: $allergen }) {
      recipeAllergen {
        allergen {
          id
          name
        }
      }
    }
  }
`;

export default createFragmentContainer(AllergenRecipeModal, {
  allAllergen: graphql`
    fragment AllergenRecipeModal_allAllergen on AllergenNodeConnection {
      edges {
        node {
          id
          name
        }
      }
    }
  `,
});
